import { RouterModule, Routes } from '@angular/router';
import { RootUserGuideRoutes } from './root-routes';
import { NgModule } from '@angular/core';
import { HomePageComponent } from './home-page/home-page.component';
import { CategoryComponent } from './category/category.component';
import { SubCategoryComponent } from './category/sub-category/sub-category.component';

const routes: Routes = [
  {
    path: RootUserGuideRoutes.Home,
    component: HomePageComponent,
    pathMatch: 'full'
  },
  {
    path: ':id',
    component: CategoryComponent,
    children: [
      {
        path: ':item',
        component: SubCategoryComponent,
      }
    ]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
